import React from 'react';
import { Helmet } from 'react-helmet';
import { Switch, Route, Redirect } from 'react-router-dom';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import OrganizationHasWorkTypesGate from 'components/OrganizationHasWorkTypesGate';

// @ts-ignore
import Tasks from './scenes/Tasks';
import Timesheet from './scenes/Timesheet';
// @ts-ignore
import TimesheetEntries from './scenes/TimesheetEntries';
import Timesheets from './scenes/Timesheets';
import MyTimesheets from './scenes/MyTimesheets';
import TimesheetHolidays from './scenes/TimesheetHolidays';
import TimesheetSubmissions from './scenes/TimesheetSubmissions';

const { REACT_APP_PROJECT_NAME } = process.env;

class Time extends React.PureComponent<any> {
    render(): React.ReactElement {
        return (
            <ErrorBoundary
                namespace="Time"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <OrganizationHasWorkTypesGate>
                    <Helmet>
                        <title>Time - {REACT_APP_PROJECT_NAME}</title>
                    </Helmet>
                    <Switch>
                        <Redirect
                            exact
                            from="/organization/time/"
                            to="/organization/time/timesheets"
                        />
                        <Route
                            exact
                            path="/organization/time/entries"
                            component={TimesheetEntries}
                        />
                        <Route
                            exact
                            path="/organization/time/timesheets"
                            component={Timesheets}
                        />
                        <Route
                            exact
                            path="/organization/time/my-timesheets"
                            component={MyTimesheets}
                        />
                        <Route
                            exact
                            path="/organization/time/timesheets/:timesheetId(\d+)"
                            component={Timesheet}
                        />
                        <Route
                            exact
                            path="/organization/time/tasks"
                            component={Tasks}
                        />
                        <Route
                            exact
                            path="/organization/time/holidays"
                            component={TimesheetHolidays}
                        />
                        <Route
                            exact
                            path="/organization/time/submissions"
                            component={TimesheetSubmissions}
                        />
                        <Redirect
                            from="/organization/time/*"
                            to="/organization/time/timesheets"
                        />
                    </Switch>
                </OrganizationHasWorkTypesGate>
            </ErrorBoundary>
        );
    }
}

export default Time;
